export const defaultThemeStyles = {
    blockShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
}
